module.exports = __webpack_public_path__ + "static/media/SM-MT2-TRIAL.832d0d5d.mp3";